module.exports = {
  "FoodB_manager_Kwwl_Cjll": "Desde el día 8 hasta el final del programa, invierte entre {{amount1}} y {{amount2}} para obtener una recompensa de la plataforma del {{rate1}}.",
  "FoodB_manager_jhXU_ptlV": "Total de veces que se hizo clic en tu anuncio",
  "FoodB_manager_OKSu_qWyl": "No está permitido realizar modificaciones durante el periodo de vigencia de las recompensas; esta opción estará disponible cuando el evento finalice el {{end_data}}",
  "FoodB_images_tgoc_AhLQ": "Disponible",
  "FoodC_information_uZqE_salQ": "Al marcar la casilla, aceptas los Términos y Condiciones",
  "FoodB_Overview_AasD_LvfW": "Ver más",
  "FoodB_Optimize_Store_nGtj": "Tienda",
  "FoodB_manager_sgsH_EpiM": "día",
  "soda-b-web-i18n---JPG或PNG格式，需要小于5MB": "Las imágenes deben ser en formato JPG o PNG menores a 5 MB.",
  "FoodB_Workflow_tjxT_OoQU": "Solo se admiten imágenes JPG, JPEG y PNG, con una dimensión de entre 450x450 y 1124x1124 pixeles.",
  "FoodB_manager_HqjV_CxOA": "Tu presupuesto no cumple con los requisitos de la promoción. Te recomendamos agregar presupuesto para acceder a las promociones",
  "FoodB_manager_ntwn_wBNk": "Impresiones del anuncio",
  "FoodB_images_qpuG_DTcO": "Baja calidad",
  "FoodB_manager_aCSR_lQaQ": "semana",
  "FoodB_1_gZUg_HAAY": "Continuar",
  "FoodB_modification_Confirmation_ehVU": "Confirmar",
  "FoodB_1_NbSA_cYbD": "Información adicional del ID de la tienda",
  "FoodB_guidance_ympr_VDEB": "15% de dto.",
  "FoodB_V_Cancel_ELKJ": "Cancelar",
  "FoodB_ads_PRAv_IxKG": "Este es el monto total que gastaste por este anuncio",
  "FoodB_manager_BMOX_RrUm": "Gratis los primeros 7 días",
  "FoodB_images_zcVM_dgvs": "Sin foto",
  "FoodB_202403_iElx_PrgH": "Se necesita acceso al álbum de fotos. Activa los permisos e inténtalo de nuevo.",
  "FoodB_IOS_bkpb_pDAZ": "Se marcó como no disponible",
  "FoodB_Workflow_wQEs_xfyz": "Por favor, ingresa",
  "FoodB_ads_iUsb_wdEa": "Publicar un anuncio",
  "FoodB_ads_JKaI_zpdU": "No se pudo reiniciar",
  "FoodB_optimization_lHJe_wjVZ": "{{num}} vendido(s) por mes",
  "FoodB_Workflow_YhcO_slrY": "Selecciona un motivo",
  "FoodB_structure_Next_step_GKKZ": "Siguiente",
  "FoodB_202403_tIbT_QIhv": "Descargado correctamente",
  "FoodB_structure_If_the_qaXe": "Si este producto es una parte obligatoria de cualquiera de los siguientes productos, marcarlo como no disponible hará que también se marquen como no disponibles los otros productos",
  "FoodB_edit_iIzf_VxWT": "Precio del grupo modificador",
  "FoodB_ads_Vuno_mXMy": "Pausar",
  "FoodB_IOS_UOug_fSFt": "Ver menos",
  "FoodB_manager_ZQKX_FOdY": "Gratis desde hoy hasta el {{trail_end_date}}",
  "FoodB_202507_Mmtm_bVsd": "Código de verificación",
  "FoodB_ads_wEEv_oKzi": "Ventas logradas con los anuncios publicados",
  "soda-b-web-i18n---确认使用审核中的菜品图片？在审核通过前用户将看不到此图片，若审核不通过请重新选择": "Esta imagen de producto está pendiente de revisión y los clientes no la verán aún. ¿Utilizar de todas formas?",
  "FoodB_manager_cfaa_kvuC": "Vistas del anuncio",
  "FoodB_ads_AbgR_WCms": "ROI",
  "FoodB_structure_The_group_yaQn": "El grupo modificador {{group_name}} está incompleto y no puede marcarse como disponible. Edítalo e inténtalo de nuevo.",
  "FoodB_Workflow_GJjA_zxpx": "Motivo",
  "soda-b-web-i18n---项目名称": "Nombre del producto",
  "FoodB_Workflow_LMPG_cGGe": "Cancelar",
  "FoodB_ads_fbjh_KkrE": "{{amount}} (compartido entre todas las tiendas que publican un anuncio)",
  "FoodB_1_rrzc_FYjd": "Marcar la casilla indica la aceptación de",
  "FoodB_diagnosis_Platform_Library_wNVo": "Galería",
  "FoodB_b_Merchant_activities_AOMe": "Eventos de promociones",
  "FoodB_ads_kQlR_vLwo": "Preguntas frecuentes",
  "FoodB_edit_Kpjr_ClVJ": "Enviar cambios",
  "FoodB_event_gnlU_HgeW": "Recompensas del Programa",
  "FoodB_signup_Rpjk_VExr": "Marca la casilla para aceptar los T&C",
  "取消": "Cancelar",
  "FoodB_structure_Only_the_TlfX": "Marcar este producto como no disponible",
  "FoodB_manager_kgoO_KDWx": "Pedidos a partir del anuncio",
  "FoodB_images_hyZS_lUdA": "Ventas ▲",
  "Gattaran_System_stOW_oOzc": "Editar",
  "FoodB_202507_zUrC_RTLN": "El código de verificación no puede estar vacío",
  "FoodB_guidance_qLuz_cdFT": "Los combos con descuentos del 15% o más pueden participar en campañas promocionales",
  "FoodB_app_HCGr_VzRg": "Precio orig. en negro",
  "FoodB_202412_AFEo_IMDT": "Ver",
  "FoodB_images_Odmy_EpkO": "Repetida",
  "全部": "Todos",
  "FoodB_202507_VtFw_lWoZ": "El código de verificación debe tener seis dígitos",
  "FoodB_end_wXDp_EzMh": "Este campo no puede estar vacío",
  "FoodB_Notification_cXDd_hXys": "Confirmar",
  "FoodB_structure_There_are_IFaR": "Hay más de un producto con el mismo nombre. Elige qué productos marcar como no disponibles",
  "FoodB_ads_eLJV_rpQs": "Se reanudó correctamente",
  "FoodB_images_SJsQ_RTPC": "Fija",
  "FoodB_202507_Kvbw_JjQU": "La invitación venció. Por favor, ponte en contacto con la tienda para obtener una nueva",
  "FoodB_ads_LYLE_IJlq": "Términos y Condiciones de Anuncios",
  "FoodB_ads_JrZk_DAPd": "Crear mi plan de anuncios",
  "FoodB_end_tShf_yvRL": "Ingresar",
  "FoodB_1_GGvN_vWXE": "Carga correcta",
  "soda-b-web-i18n---必选": "Obligatorio",
  "FoodB_Workflow_TGPT_ERNF": "Enviar",
  "FoodB_202507_pyLz_EIhG": "Verificar y continuar",
  "FoodB_2_GMQA_WoAd": "Ingresa el ID o los ID de la tienda para esta solicitud. Usa comas (',') para separar varios ID.",
  "FoodB_raise_GzoV_LxqP": "No se pudo cambiar el precio de uno o más productos. Por favor, revisa los detalles en la app de {{sys}}.",
  "FoodB_end_jDIn_MChP": "Nombre de la tienda",
  "FoodB_IOS_aPdf_nqLr": "Estado de la imagen",
  "FoodB_ads_dOkB_VPYp": "Tiendas para la publicación de anuncios",
  "FoodB_Subscribe202412_zlrO_JCcA": "Atención",
  "FoodB_20240530_DIPS_Umqk": "Entendido",
  "FoodB_1_PyNi_AWeH": "Enviar",
  "FoodB_Refund_VgKI_KAdX": "Nombre del producto",
  "FoodB_structure_Remove_items_mzeF": "Marcar todos los productos con el mismo nombre (incluyendo subproductos) como no disponibles",
  "FoodB_20220201_Confirmation_uFDW": "Confirmar",
  "FoodB_1_MWFs_AuJo": "Si tienes información adicional (por ejemplo, la URL del menú del restaurante), puedes ingresarla aquí.",
  "FoodB_manager_dbWL_uoLT": "Total de veces que se vio tu anuncio",
  "FoodB_202507_AaJV_ONrK": "Descargar",
  "FoodB_202507_eldX_PSOm": "Reenviar",
  "FoodB_examination_RLMB_cTnU": "Este producto no se puede vender debido a que su precio es más alto que el precio del menú físico o de otra plataforma. Por favor, modifica los precios del producto y del modificador para que sean más bajos que los precios del menú físico o de otra plataforma, y luego vuelve a marcar el producto como disponible.",
  "FoodB_images_elYf_pCKJ": "Agregar",
  "FoodB_1_IXST_AqGw": "Para mantener la coherencia con los precios acordados y cumplir con los Términos y Condiciones de uso de la plataforma, podemos sugerir ajustes de precio al crear nuevos menús. Estas sugerencias buscan mantener precios razonables y mejorar la experiencia de los usuarios. Si tienes preguntas sobre estas sugerencias o sobre los Términos y Condiciones, contacta a tu asesor, envíanos un mensaje desde la app o llama a nuestro equipo de soporte.",
  "FoodB_manager_KMon_Ucmi": "Recompensa de hasta un {{{max_rate}}} después",
  "FoodB_optimization_Image_Requirements_RAjc": "Requisitos de la imagen: archivo JPG o PNG de menos de 5 MB",
  "FoodB_app_mvOp_PSvy": "Comer en el lugar",
  "Gattaran_MenuAPI_CRDn_HYld": "Las dimensiones de las imágenes deben ser de al menos {{size}}",
  "FoodB_manager_Pmbs_CYnh": "Participa en la promoción para obtener un total de {{amount}} días de recompensas para anuncios. Los primeros 7 días de publicidad de tu tienda son gratuitos",
  "FoodB_examination_jQot_WFxD": "Productos con precios más altos temporalmente eliminados",
  "FoodB_dishes_golj_IhqE": "El precio del producto excede el permitido. Ajusta el precio por debajo del precio controlado antes de marcarlo como disponible.",
  "FoodB_Workflow_DPbq_FztV": "Cargar evidencia de respaldo",
  "FoodB_lines__item_gLep": "No se puede cambiar la disponibilidad de {{item}}. Motivo:",
  "FoodB_Workflow_BldJ_kyRF": "Notas",
  "FoodB_ads_kkCY_VhnR": "Detalles del anuncio",
  "FoodB_diagnosis_Add_the_ROcc": "Especifica para cuántas personas es el combo",
  "FoodB_images_NRvd_CfNM": "Ubicación del producto",
  "FoodB_images_kqnL_zpUk": "Las imágenes de buena calidad pueden hacer que los usuarios realicen más pedidos.",
  "FoodB_manager_rzAQ_djgI": "Desde el {{start_data}} hasta el {{end_data}}, la plataforma cubre {{p_budget}}/día y la tienda cubre {{b_budget}}/día",
  "FoodB_manager_HaIz_XbUw": "Puedes ver las ganancias del anuncio y más información en la página “Detalles del anuncio”",
  "soda-b-web-i18n---没有图片": "No hay imágenes",
  "FoodB_2_fvcH_GGWS": "Volver al menú",
  "FoodB_IOS_uqRa_ZgjI": "Se marcó como disponible",
  "确认": "Sí",
  "FoodB_manager_SKhT_KcPn": "Presupuesto para el anuncio",
  "FoodB_structure_This_item_Kjzb": "Este producto está en los grupos modificadores del siguiente producto. Marcarlo como no disponible hará que también se marque como no disponible en los siguientes grupos modificadores",
  "FoodB_diagnosis_Search_DYwq": "Buscar",
  "FoodB_manager_ZTpO_CxTr": "Desde hoy hasta el {{end_data}}, la plataforma cubre {{p_budget}}/semana y la tienda cubre {{b_budget}}/semana",
  "FoodB_IOS_GAPD_nKPg": "Estado de las ventas",
  "FoodB_images_Ifqh_ZbIZ": "Todos",
  "FoodB_app_AtpY_Aybm": "{{ratio}}% de dif.",
  "FoodB_50M_woqw_PJvI": "Los archivos que intentas cargar son demasiado grandes. Las imágenes deben tener menos de {{pic_num1}} y los documentos deben tener menos de {{pic_num2}}. Por favor, reduce el tamaño y vuelve a subirlos.",
  "FoodB_Workflow_oCVA_DKpq": "Las imágenes deben estar en formato {{format}} y tener una resolución de al menos {{ratio}}.",
  "FoodB_end_btsz_MEkI": "Registro de acciones",
  "FoodB_ads_GmKW_brRz": "Este es el total de ventas generadas por usuarios que realizaron pedidos en un plazo de siete días después de ver tu anuncio.",
  "FoodB_202403_GUuf_Hxvh": "DiDi Tu Negocio",
  "FoodB_edit_FUgf_iAPR": "Error del sistema. Inténtalo de nuevo.",
  "FoodB_images_Ruvq_UOGP": "Ventas ▼",
  "FoodB_ads_hsyI_CluZ": "Gastos de anuncios",
  "FoodB_images_sDvo_WhBT": "Los productos que no tienen imágenes o que tienen imágenes repetidas no podrán participar en las promociones que se muestran a continuación, lo que podría afectar su visibilidad.",
  "FoodB_edit_EauY_eVbs": "No pueden cambiarse los precios de los productos incluidos en combos o promociones",
  "FoodB_ads_EUKq_wQqg": "Personalizado",
  "FoodB_3_Meij_rAcc": "Sin resultados",
  "FoodB_manager_jDsw_neeZ": "El presupuesto total para anuncios con la recompensa es de {{total_amount}} por día",
  "FoodB_manager_PNYI_bdhw": "Por favor, haz clic {en la parte superior izquierda de la página} para regresar a la lista",
  "FoodB_manager_QWyb_fTPV": "Una vez que la recompensa finalice el {{date}}, el presupuesto para anuncios volverá a ser de {{b_budget}} por semana",
  "FoodB_diagnosis_Fill_in_izgd": "Ingresa la descripción del producto",
  "FoodB_manager_lrhZ_GgWG": "Desde el {{start_data}} hasta el {{end_data}}, la plataforma cubre {{p_budget}}/semana y la tienda cubre {{b_budget}}/semana",
  "FoodB_manager_Vavg_QJRU": "Desde hoy hasta el {{end_data}}, la plataforma cubre {{p_budget}}/día y la tienda cubre {{b_budget}}/día",
  "FoodB_ads_mCxj_GQTc": "Costo (costo por cada clic de usuario)",
  "FoodB_202311_BGpD_RoKX": "No hay más",
  "FoodB_Brazil_ajzJ_JuVl": "En el modelo de franquicia de marca, no tienes permiso para realizar esta acción. Para continuar, por favor, comunícate con el asesor.",
  "FoodB_images_dCkE_owJP": "Las imágenes repetidas pueden reducir la visibilidad de los productos y resultar en menos pedidos.",
  "FoodB_list_pycq_NFTr": "Ver más",
  "FoodB_guidance_KjqW_ZOOL": "Los descuentos del 20 % o más pueden aumentar la posibilidad de mejorar las ventas de los combos",
  "soda-b-web-i18n---添加": "Agregar",
  "soda-b-web-i18n---可选": "Opcional",
  "FoodB_202507_IeTZ_IsVt": "Código de verificación no válido. Por favor, intenta de nuevo",
  "FoodB_list_RMhg_oxdJ": "Ver menos",
  "soda-b-web-i18n---请输入价格": "Ingresa el precio",
  "FoodB_202507_TYLB_oGxx": "Crea tu cuenta de repartidor",
  "FoodB_manager_tfuO_mmOQ": "Invierte {{amount3}} o más, y obtén una recompensa de la plataforma del {{rate3}}",
  "FoodB_202603_KqsN_oVLw": "Producto solo en línea, sin datos de comparación de precios",
  "FoodB_ads_Mhsz_vxcz": "Pausar el anuncio podría reducir la visibilidad de tu tienda en la aplicación, lo que podría afectar tus pedidos.",
  "FoodB_structure_Available_items_YZlI": "Marcar producto como disponible",
  "FoodB_manager_UQMz_EKvg": "Clics en el anuncio",
  "soda-b-web-i18n---请选择": "Seleccionar",
  "FoodB_Workflow_sLBZ_kEUz": "Apelación",
  "FoodB_structure_Confirmation_KdZD": "Confirmar",
  "FoodB_202507_lSPc_azJu": "¡Hola! {{nick_name}} te invita a realizar entregas para {{store_name}}.",
  "FoodB_images_dkwU_DozC": "Quitar",
  "FoodB_ads_xHIG_ssdt": "Usuarios objetivo",
  "FoodB_ads_jnGH_TBtE": "Última actualización el {{date}}",
  "FoodB_manager_dbGg_urLm": "Guardar cambios",
  "FoodB_ads_EuaQ_gUWs": "Presupuesto semanal",
  "FoodB_end_vWCI_Khdj": "ID de la tienda",
  "FoodB_manager_cYvu_RUOJ": "El gasto diario promedio en una semana. El gasto semanal total tiene un límite de siete veces el presupuesto diario.",
  "FoodB_menu_ezpD_HgJQ": "Entrega",
  "FoodB_manager_Zkso_jGUU": "El presupuesto total para anuncios con la recompensa es de {{total_amount}} por semana",
  "FoodB_I_FKuu_NKAq": "Se envió correctamente",
  "FoodB_guidance_KPTM_jtce": "30% de dto.",
  "soda-b-web-i18n---确认更换图片": "Confirmar el reemplazo de la imagen",
  "FoodB_Management_ETTC_atmq": "Aviso",
  "FoodB_Workflow_YTgN_Kqvj": "Reseñas de usuarios",
  "FoodB_202507_KAIz_QuzG": "Después de descargar e instalar la aplicación, inicia sesión con el número de celular verificado y comienza a usar la app.",
  "FoodB_ads_SKdz_cIQv": "Estas son las ganancias de las ventas que recibiste por cada {{amount}} en gastos de anuncios. Este monto se calcula al dividir las ventas del anuncio entre el monto que invertiste en él.",
  "FoodB_202403_Oupx_AERj": "Hubo un error. Intenta descargarlo de nuevo.",
  "FoodB_ads_fFZs_fhfw": "¿Confirmas que quieres pausar el anuncio?",
  "FoodB_1_CntW_EOUd": "Sube una foto clara y completa del menú del restaurante.",
  "FoodB_one_Create_categories_NYkB": "Crea una categoría primero",
  "FoodB_202507_pnqc_SLIH": "¡Verificación de {{number}} completada con éxito!",
  "FoodB_1_GETK_EwnC": "Entendido",
  "FoodB_ads_ohud_CQNg": "Reanudar",
  "FoodB_manager_Taew_Vhya": "La cantidad total de usuarios que vieron el anuncio",
  "FoodB_app_xjTx_iQII": "Dif. dentro de lím.",
  "FoodB_record_aMyR_GHwi": "Crear",
  "FoodB_ads_TBRW_mcgC": "Ver",
  "FoodB_guidance_TyKs_OJEe": "El precio no puede ser 0",
  "FoodB_Workflow_NsGd_FBUJ": "Enviado correctamente",
  "Gattaran_app_wQyy_gBIH": "Esta función solo está disponible en la aplicación de la Tienda y actualmente no es compatible con {{app}}",
  "FoodB_ads_aBTZ_puGq": "Tus planes de anuncios",
  "FoodB_manager_pkmQ_slMM": "Registrado con éxito",
  "FoodB_app_zESd_XsMb": "Precio c/dscto. en negro",
  "FoodB_edit_OzpO_pQjy": "Editar producto",
  "FoodB_structure_Dishes_off_DpDW": "Marcar el producto como no disponible",
  "FoodB_manager_bfcy_TuLs": "El monto máximo gastado en publicidad por semana",
  "FoodB_ads_AUHA_UKTn": "Estado de vigencia",
  "FoodB_images_mWCv_qwcI": "No disponible",
  "FoodB_diagnosis_Package_prices_HhZb": "El precio del combo es mayor al precio máximo",
  "FoodB_IOS_DuJM_XIww": "Ver más",
  "FoodB_app_rJMe_JvWP": "Menú físico: {{DineInSpreadRatio}}% dif.",
  "FoodB_manager_WiiZ_fQTr": "Clics en el anuncio",
  "FoodB_202507_jFRj_JuzW": "Enviar código de verificación",
  "FoodB_manager_tluR_ydNq": "Se cambió con éxito",
  "FoodB_App__CeNy": "No hay combos recomendados",
  "FoodB_202507_gJQz_KNsm": "Por favor, verifica tu número de celular por mensaje de texto para ayudarnos a confirmar que está activo:",
  "soda-b-web-i18n---图片不合法": "Imagen ilegal",
  "FoodB_menu_TLDI_rbsq": "Recolección",
  "Gattaran_System_FPHM_FNhp": "Planes publicitarios",
  "soda-b-web-i18n---审核中": "En revisión",
  "FoodB_manager_gCEg_QRci": "Reinicia los anuncios antes del {{end_data}} para continuar aprovechando la recompensa de la plataforma",
  "FoodB_end_txmi_EUkK": "Creado correctamente",
  "FoodB_guidance_tIZK_FnCu": "20% de dto.",
  "FoodB_images_RTGc_aPGv": "¿Quieres tomar fotos de los productos? ¡Prueba la cámara!",
  "FoodB_end_EXUZ_AybF": "He leído y acepto los",
  "FoodB_images_yEwu_BOgv": "Ver más",
  "FoodB_manager_YJWG_TGEr": "Invierte entre {{amount2}} y {{amount3}}, y obtén una recompensa de la plataforma del {{rate2}}",
  "FoodB_examination_iFla_jDwD": "Uno o más productos no se pueden vender porque sus precios son más altos que los del menú para comer en el lugar. Por favor, revisa la app de {{sys}} para más detalles.",
  "FoodB_1_oGoo_Lqkf": "Aplicación de menú",
  "FoodB_ads_zdck_cALt": "Datos de rendimiento",
  "FoodB_manager_OJaX_kWqN": "ROAS",
  "FoodB_manager_zkAd_zMmA": "La cantidad total de usuarios que hicieron clic en el anuncio",
  "FoodB_diagnosis_Store_Gallery_izRn": "Fotos de la tienda",
  "Gattaran_System_MdOu_YQGa": "Presupuesto diario",
  "FoodB_1_iGrV_whcl": "Regresar",
  "FoodB_202507_oTId_ZJEY": "Descargar aplicación",
  "soda-b-web-i18n---审核未通过": "No aprobado",
  "FoodB_Packages_WVQT_trjL": "Nombre del modificador",
  "FoodB_edit_GGaD_NBFy": "Precio del producto",
  "FoodB_manager_cAxE_aMhz": "La cantidad de pedidos realizados por usuarios dentro de los siete días posteriores a la visualización del anuncio",
  "soda-b-web-i18n---请输入项目名称": "Ingresa el nombre del producto",
  "FoodB_ads_WAjG_IoqX": "Anuncio",
  "FoodB_ads_mKyB_UXoD": "Términos y Condiciones",
  "FoodB_app_LKsL_pZNy": "Black: {{BlackSpreadRatio}}% de dif.",
  "FoodB_manager_lvpx_Fggm": "Obtén una recompensa de la plataforma del {{rate}} desde el día 8 hasta el final de la promoción",
  "FoodB_combination_dMkH_fHZW": "El monto debe estar entre {{amount1}} y {{amount2}}",
  "FoodB_app_XVqb_dBQE": "Dif. fuera de lím.",
  "Gattaran_System_wrVY_PjDQ": "Nombre del plan",
  "FoodB_manager_Adkb_bXXA": "Una vez que la recompensa finalice el {{date}}, el presupuesto para anuncios volverá a ser de {{b_budget}} por día",
  "FoodB_guidance_LLRv_LmOz": "Los combos con descuentos del 30% o más pueden obtener más visibilidad en la sección “Descuentos deliciosos”.",
  "已加载全部菜品": "Se cargaron todos los productos del menú",
  "搜索": "Buscar",
  "未搜索到相关菜品": "Sin resultados de búsqueda",
  "暂无菜品": "No hay productos en el menú",
  "搜索结果": "Resultados de búsqueda",
  "菜品名称、加料": "Nombre del producto",
  "下架": "Poner no disponible",
  "上架": "Poner disponible",
  "菜品列表": "Lista de productos",
  "FoodB_0526_CJIS_cGuT": "Store Delivery",
  "FoodB_0526_YWxv_qCMp": "Verify Order Locator Code",
  "FoodB_0526_xxjK_BrKm": "Verify Customer Confirmation Code",
  "FoodB_0526_CWJT_tJDS": "When you meet the customer and hand over the order, ask them to provide a {{number4}}-digit verification code to confirm delivery.",
  "FoodB_0526_ZwcV_xubO": "Complete Delivery",
  "FoodB_0526_pago_jZCL": "Back",
  "FoodB_0526_wOWe_bCYw": "The customer confirmation code entered is unrecognized. Please try again.",
  "FoodB_0526_rIpi_tOxQ": "The order locator code (an {{number3}}-digit number) can be found on the order receipt. It’s used to identify your order and can also serve as an extension number to contact the customer.",
  "FoodB_0526_ALSJ_vOIv": "Verify and Continue",
  "FoodB_0526_ItLx_NtXl": "The locator code entered is unrecognized. Please try again.",
  "FoodB_0526_WpAq_pLIl": "Have you arrived at the delivery location?",
  "FoodB_0526_HUpD_BgTa": "You'll need the order locator code and customer confirmation code to confirm delivery.",
  "FoodB_0526_Ugoi_wHIL": "I have arrived at the location",
  "FoodB_0526_Ohci_xuvI": "Business maintenance is in progress. Please stay tuned",
  "FoodB_0526_LSWB_SqBa": "Locator",
  "FoodB_0526_obJO_XULq": "Step {{number1}}",
  "FoodB_0526_BiXD_Hdyk": "Step {{number2}}",
  "FoodB_0526_RjfK_pdye": "Thank you for your delivery. The order has been confirmed as delivered.",
  "FoodB_notification_hZjl_FphL": "Your item name or description contains invalid words. Please check and try again.",
  "FoodB_APP_mEnV_wsTd": "Investment Amount Adjustment Log",
  "FoodB_APP_PblC_TgZp": "Daily Maximum Investment Amount",
  "FoodB_APP_ndJV_wijx": "Set Investment Amount",
  "FoodB_APP_zgwc_zcsv": "Please set the maximum daily investment amount for each store. Your daily spending will not exceed this limit",
  "FoodB_APP_Pcvl_NpRz": "Please enter",
  "FoodB_APP_bYTM_LhKX": "Save",
  "FoodB_APP_xAjf_jDPk": "Not Set",
  "FoodB_APP_PxtZ_SCXD": "Manage Smart Promotion Investment Amount",
  "FoodB_b_rWzS_qxWT": "Minimum input is {{amount}}. Investing less may not be effective",
  "FoodB_b_eskb_LyNU": "Maximum input is {{amount}}. Investing more may not be effective",
  "FoodB_APP_pPJg_kXTB": "Action Performed by",
  "FoodB_APP_rhVY_pJAy": "Daily maximum investment amount saved successfully",
  "FoodB_202601_CdHf_ZlRj": "Inventory",
  "FoodB_202601_sCuN_CshI": "Item Inventory",
  "FoodB_202601_cyGw_MMum": "Unlimited Inventory",
  "FoodB_202601_VXKL_AVFs": "Sales will be suspended",
  "FoodB_202601_XPTD_CEFY": "The item is out of stock and is temporarily unavailable for sale",
  "FoodB_202601_RpBl_cvEL": "Modifier Inventory",
  "FoodB_202601_aEjt_IJpA": "Set Inventory",
  "FoodB_202601_rjNL_gHnh": "Auto-update inventory",
  "FoodB_202601_yJMW_FLxF": "Automatically updated daily around {{stock_auto_update_time}} AM to:",
  "FoodB_202601_FJrT_ckty": "Inventory quantity",
  "FoodB_202601_pAeY_gbea": "Please enter a number greater than 0",
  "FoodB_RTBO_bbbP_IepA": "The file type you uploaded is invalid. Please check and try again.",
  "FoodB_dishes_ZbSd_OYxo": "Select how you would like the platform to help create your menu",
  "FoodB_dishes_rBbi_KngX": "Menu from another online ordering platform",
  "FoodB_dishes_BkFn_Fosv": "Provide your Dine-in Menu",
  "FoodB_dishes_JDKN_Pnvu": "Upload a clear image or file of the menu. JPG, JPEG, PNG, and PDF formats are supported. Maximum file size: 50 MB",
  "FoodB_dishes_HHaf_pmiF": "Upload File",
  "FoodB_RTBO_NKhs_wDpv": "Maximum file count limit of {{maxCount}} exceeded. Please try again later.",
  "FoodB_dishes_Xarz_Epsk": "Please provide your menu link from another online ordering platform",
  "FoodB_dishes_pbEP_eXoT": "Please enter your menu link from another online ordering platform",
  "FoodB_display_Psdy_UGlS": "Please enter the right menu link where customers can see items.",
  "FoodB_dishes_Bxue_jOmR": "Please click to upload your dine-in menu",
  "FoodB_dishes_awQC_brER": "Please upload your dine-in menu",
  "FoodB_process_ZkgJ_HwNF": "Reason for Rejection",
  "FoodB_process_rfeW_NltJ": "Submission Time",
  "FoodB_process_cfAj_XFEi": "Submitter",
  "FoodB_process_iTOg_nUJw": "Submission Type",
  "FoodB_process_iYeP_xITi": "Submission Content",
  "FoodB_process_UHWD_gXzW": "Menu URL from Another Online Ordering Platform",
  "FoodB_process_CRbd_ZZGv": "Dine-in Menu",
  "FoodB_process_pREA_cDkb": "DiDi Rep Manager",
  "FoodB_demand_Zykn_OlKm": "Your menu is expected to be ready within 48 hours. Thanks for your patience",
  "FoodB_Menu_rRNC_FuAD": "Your menu creation request was rejected. Please try again later.",
  "FoodB_process_tooV_lKge": "Request Details",
  "FoodB_process_NiGM_rpYW": "Request Again",
  "FoodB_demand_AGIz_wbYQ": "You have submitted your menu creation request",
  "FoodB_process2_cNUJ_FjYV": "Thank you for your submission! Your menu will be ready as soon as we can",
  "FoodB_process2_xkgO_snCf": "Oops! There was an issue with your application",
  "FoodB_process2_ujgc_Ejiq": "Sorry, the information you submitted is incorrect. Please check and try again.",
  "FoodB_Menu_kRrV_DCKl": "Include at least the item names, prices, and descriptions in the menu image(s) or file(s).",
  "FoodB_Menu_kbbj_QOWO": "Don’t upload non-menu image(s), such as item image.",
  "FoodB_display_ZlIm_vzIm": "Example",
  "FoodB_display_PGUh_ESfK": "Images are for reference only, not for actual use.",
  "FoodB_Menu_XoRP_lPGd": "Platform-Assisted Menu Creation",
  "FoodB_Menu_mxTc_dGvV": "Submit your menu file and the platform will help you create your menu.",
  "FoodB_dishes_NjWV_wHOm": "Submit",
  "FoodB_operations_LIuT_ryiH": "Thank you for the submission! Your menu will be ready as soon as we can.\n"
}